// The annotation type registry. Each entry is a self-contained schema plugin;
// adding a new annotation schema means appending one entry here — no changes to
// the editor, store, or markers are required.

import type { AnnotationTypeDef } from './annotationType.interface.js';
import { EXPECTED_ACTION_TYPE } from './expectedActionType.js';

/** All registered annotation types, in dropdown order. */
export const ANNOTATION_TYPES: readonly AnnotationTypeDef[] = [
  EXPECTED_ACTION_TYPE,
];

/** The type selected by default when the editor first opens. */
export const DEFAULT_ANNOTATION_TYPE: AnnotationTypeDef = EXPECTED_ACTION_TYPE;

/** Every registered kind, for kind-aware "annotated" discovery. */
export const ANNOTATION_KINDS: readonly string[] = ANNOTATION_TYPES.map(
  (type) => type.kind,
);

/** Resolve a registered type by kind, or undefined when unknown. */
export function getAnnotationType(kind: string): AnnotationTypeDef | undefined {
  return ANNOTATION_TYPES.find((type) => type.kind === kind);
}
